import { Controller } from '@hotwired/stimulus';
import throttle from 'lodash/throttle';

export default class extends Controller {
    connect() {
        document.addEventListener('scroll', throttle(this.callback, 300));
    }

    callback() {
        if (window.scrollY > 150) {
            document.querySelector('body').classList.add('fixed-nav');
        } else {
            document.querySelector('body').classList.remove('fixed-nav');
        }
    }

    toggleMobileMenu() {
        this.element.classList.toggle('mobile-active');
        document.querySelector('html').classList.toggle('mobile-visible');
    }

    expandMobileMenuItem(e) {
        e.preventDefault();
        e.stopPropagation();
        e.currentTarget.parentElement.parentElement.classList.toggle('expanded');
    }
}
